/* js/pages/ConstellationMapPage.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import Header from '../components/Header.svelte';
import MapLibre from '../components/MapLibre.svelte';
import SimpleMarkerLibre from '../components/SimpleMarkerLibre.svelte';
import UserMarkerLibre from '../components/UserMarkerLibre.svelte';
import MapPointerButton from '../components/MapPointerButton.svelte';
import ParcoursPath from '../components/ParcoursPath.svelte';
import GeoLocationStartButton from '../components/GeoLocationStartButton.svelte';

import {
	geoLocationManager,
	GeolocationEventType,
	GeoLocationServiceState
} from '../GeoLocationManager';

import { appRouter } from '../appRouter.js';
import { computeBounds, genevaCoords, getBbox } from '../geoUtils';
import { db } from '../Db.js';
import { mapEventProvider } from '../mapEventProvider.js';
import { onMount, onDestroy } from 'svelte';
import { flyToProvider } from '../providers.js';
import distance from '@turf/distance';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[23] = list[i];
	child_ctx[25] = i;
	return child_ctx;
}

// (168:0) {#if haltes}
function create_if_block(ctx) {
	let div;
	let maplibre;
	let current;

	maplibre = new MapLibre({
			props: {
				startCoordinates: genevaCoords,
				startZoom: 13,
				onLoad: /*onMapLoaded*/ ctx[6],
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			div = element("div");
			create_component(maplibre.$$.fragment);
			attr(div, "class", "map-container svelte-1bsnlr7");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(maplibre, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const maplibre_changes = {};

			if (dirty & /*$$scope, haltes, closestHaltes, mapIsReady, autoCenteringActive*/ 67108894) {
				maplibre_changes.$$scope = { dirty, ctx };
			}

			maplibre.$set(maplibre_changes);
		},
		i(local) {
			if (current) return;
			transition_in(maplibre.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(maplibre.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(maplibre);
		}
	};
}

// (174:12) {#if mapIsReady}
function create_if_block_1(ctx) {
	let each_1_anchor;
	let current;
	let each_value = /*haltes*/ ctx[1];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*haltes, detectionRadius, closestHaltes, gotoHalte*/ 50) {
				each_value = /*haltes*/ ctx[1];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (175:16) {#each haltes as halte, index}
function create_each_block(ctx) {
	let simplemarkerlibre;
	let current;

	function func(...args) {
		return /*func*/ ctx[9](/*index*/ ctx[25], ...args);
	}

	function requestSelection_handler() {
		return /*requestSelection_handler*/ ctx[10](/*halte*/ ctx[23]);
	}

	simplemarkerlibre = new SimpleMarkerLibre({
			props: {
				index: /*index*/ ctx[25],
				coords: /*halte*/ ctx[23].coordinates,
				showRadius: /*index*/ ctx[25] != /*halte*/ ctx[23].idx - 1,
				radiusMeters: detectionRadius,
				clickable: /*index*/ ctx[25] == /*halte*/ ctx[23].idx,
				big: !!/*closestHaltes*/ ctx[4].find(func),
				zIndex: 10
			}
		});

	simplemarkerlibre.$on("requestSelection", requestSelection_handler);

	return {
		c() {
			create_component(simplemarkerlibre.$$.fragment);
		},
		m(target, anchor) {
			mount_component(simplemarkerlibre, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const simplemarkerlibre_changes = {};
			if (dirty & /*haltes*/ 2) simplemarkerlibre_changes.coords = /*halte*/ ctx[23].coordinates;
			if (dirty & /*haltes*/ 2) simplemarkerlibre_changes.showRadius = /*index*/ ctx[25] != /*halte*/ ctx[23].idx - 1;
			if (dirty & /*haltes*/ 2) simplemarkerlibre_changes.clickable = /*index*/ ctx[25] == /*halte*/ ctx[23].idx;
			if (dirty & /*closestHaltes*/ 16) simplemarkerlibre_changes.big = !!/*closestHaltes*/ ctx[4].find(func);
			simplemarkerlibre.$set(simplemarkerlibre_changes);
		},
		i(local) {
			if (current) return;
			transition_in(simplemarkerlibre.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(simplemarkerlibre.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(simplemarkerlibre, detaching);
		}
	};
}

// (170:8) <MapLibre startCoordinates={genevaCoords} startZoom={13} onLoad={onMapLoaded}>
function create_default_slot(ctx) {
	let geolocationstartbutton;
	let t0;
	let usermarkerlibre;
	let t1;
	let mappointerbutton;
	let t2;
	let if_block_anchor;
	let current;
	geolocationstartbutton = new GeoLocationStartButton({});
	usermarkerlibre = new UserMarkerLibre({});

	mappointerbutton = new MapPointerButton({
			props: { active: /*autoCenteringActive*/ ctx[3] }
		});

	mappointerbutton.$on("statuschange", /*onHandleCenteringRequest*/ ctx[7]);
	let if_block = /*mapIsReady*/ ctx[2] && create_if_block_1(ctx);

	return {
		c() {
			create_component(geolocationstartbutton.$$.fragment);
			t0 = space();
			create_component(usermarkerlibre.$$.fragment);
			t1 = space();
			create_component(mappointerbutton.$$.fragment);
			t2 = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			mount_component(geolocationstartbutton, target, anchor);
			insert(target, t0, anchor);
			mount_component(usermarkerlibre, target, anchor);
			insert(target, t1, anchor);
			mount_component(mappointerbutton, target, anchor);
			insert(target, t2, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const mappointerbutton_changes = {};
			if (dirty & /*autoCenteringActive*/ 8) mappointerbutton_changes.active = /*autoCenteringActive*/ ctx[3];
			mappointerbutton.$set(mappointerbutton_changes);

			if (/*mapIsReady*/ ctx[2]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*mapIsReady*/ 4) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_1(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(geolocationstartbutton.$$.fragment, local);
			transition_in(usermarkerlibre.$$.fragment, local);
			transition_in(mappointerbutton.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(geolocationstartbutton.$$.fragment, local);
			transition_out(usermarkerlibre.$$.fragment, local);
			transition_out(mappointerbutton.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			destroy_component(geolocationstartbutton, detaching);
			if (detaching) detach(t0);
			destroy_component(usermarkerlibre, detaching);
			if (detaching) detach(t1);
			destroy_component(mappointerbutton, detaching);
			if (detaching) detach(t2);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function create_fragment(ctx) {
	let header;
	let t0;
	let div;
	let t1;
	let h2;
	let t2;
	let t3;
	let t4;
	let if_block_anchor;
	let current;
	header = new Header({ props: { title: "" } });
	let if_block = /*haltes*/ ctx[1] && create_if_block(ctx);

	return {
		c() {
			create_component(header.$$.fragment);
			t0 = space();
			div = element("div");
			t1 = space();
			h2 = element("h2");
			t2 = text("toutes les haltes ");
			t3 = text(/*constellationTitle*/ ctx[0]);
			t4 = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
			attr(div, "class", "headspacer");
			attr(h2, "class", "svelte-1bsnlr7");
		},
		m(target, anchor) {
			mount_component(header, target, anchor);
			insert(target, t0, anchor);
			insert(target, div, anchor);
			insert(target, t1, anchor);
			insert(target, h2, anchor);
			append(h2, t2);
			append(h2, t3);
			insert(target, t4, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*constellationTitle*/ 1) set_data(t3, /*constellationTitle*/ ctx[0]);

			if (/*haltes*/ ctx[1]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*haltes*/ 2) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(header.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(header.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			destroy_component(header, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div);
			if (detaching) detach(t1);
			if (detaching) detach(h2);
			if (detaching) detach(t4);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

const detectionRadius = 35; // meters

function instance($$self, $$props, $$invalidate) {
	let { params } = $$props;
	let constellationSlug;
	let constellationTitle;
	let haltes = [];
	let userPosition = geoLocationManager.currentCoords;
	let mapIsReady = false;
	let autoCenteringActive = false;
	let autoCenteringIntervalId = null;
	let triggerFlyToEvent = false;
	let haltePoints = [];
	let closestHaltes = []; // closest haltes to user

	onMount(() => {
		constellationSlug = params.constellationSlug;
		console.log("params", params, constellationSlug);
		const constellation = db.getConstellationWithSlug(constellationSlug);
		$$invalidate(0, constellationTitle = constellation.title);
		$$invalidate(1, haltes = constellation.steps);
		haltePoints = db.getHalteCoordsForConstellationWithSlug(constellationSlug);
		mapEventProvider.addListener(onMapEvent);
	});

	onDestroy(() => {
		geoLocationManager.removeEventListener(GeolocationEventType.started, onGeoLocationStarted);
		geoLocationManager.removeEventListener(GeolocationEventType.significantCoords, onGeoLocationUpdate);
		geoLocationManager.removeEventListener(GeolocationEventType.stopped, onGeoLocationStopped);
		clearInterval(autoCenteringIntervalId);
		autoCenteringIntervalId = null;
		mapEventProvider.removeListener(onMapEvent);
	});

	function onMapEvent(event) {
		if (event.type === 'dragstart') {
			// stop autocentering
			if (autoCenteringActive) {
				$$invalidate(3, autoCenteringActive = false);
				clearInterval(autoCenteringIntervalId);
				autoCenteringIntervalId = null;
			}
		}
	}

	function stopAutoCentering() {
		if (autoCenteringActive) {
			$$invalidate(3, autoCenteringActive = false);
			clearInterval(autoCenteringIntervalId);
			autoCenteringIntervalId = null;
		}
	}

	function onGeoLocationStarted() {
		stopAutoCentering();
		triggerFlyToEvent = true;
	}

	function gotoHalte(step) {
		appRouter.show(`/constellation/${step.parentSlug}/halte/${step.slug}`);
	}

	function onGeoLocationUpdate(event) {
		// console.log("geo update on path page", event.value);
		// 1 update userPosition
		userPosition = event.value;

		$$invalidate(4, closestHaltes = haltes.filter(halte => {
			const distanceToUser = distance(userPosition.coords, halte.coordinates) * 1000;
			return distanceToUser < 800;
		}));

		console.log("closestHaltes", closestHaltes);
	}

	function onGeoLocationStopped() {
		userPosition = null;
		stopAutoCentering();
		flyToMarkersAndUser();
	}

	function flyToMarkersAndUser() {
		let points = haltePoints.slice();

		if (userPosition && geoLocationManager.isStarted) {
			points.push(userPosition.coords);
		}

		const bbox = getBbox(points);
		const flyToOptions = { bounds: bbox, padding: 100 };
		flyToProvider.provide(flyToOptions);
	}

	async function onMapLoaded() {
		console.log("map ready");
		$$invalidate(2, mapIsReady = true);
		geoLocationManager.addEventListener(GeolocationEventType.started, onGeoLocationStarted);
		geoLocationManager.addEventListener(GeolocationEventType.significantCoords, onGeoLocationUpdate);
		geoLocationManager.addEventListener(GeolocationEventType.stopped, onGeoLocationStopped);
	}

	function centerHandler() {
		flyToMarkersAndUser();
	}

	function onHandleCenteringRequest(e) {
		$$invalidate(3, autoCenteringActive = e.detail.status);
		console.log("auto centering status change", autoCenteringActive);

		if (autoCenteringActive && !autoCenteringIntervalId) {
			console.log("start auto centering");
			autoCenteringIntervalId = setInterval(centerHandler, 5000);
			triggerFlyToEvent = false;
			centerHandler();
		} else {
			console.log("stop auto centering");
			clearInterval(autoCenteringIntervalId);
			autoCenteringIntervalId = null;
		}
	}

	const func = (index, halte) => halte.idx == index;
	const requestSelection_handler = halte => gotoHalte(halte);

	$$self.$$set = $$props => {
		if ('params' in $$props) $$invalidate(8, params = $$props.params);
	};

	return [
		constellationTitle,
		haltes,
		mapIsReady,
		autoCenteringActive,
		closestHaltes,
		gotoHalte,
		onMapLoaded,
		onHandleCenteringRequest,
		params,
		func,
		requestSelection_handler
	];
}

class ConstellationMapPage extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { params: 8 });
	}
}

export default ConstellationMapPage;